import React from 'react';
import {
  CalendarPlus, Gift, UserCheck, X, Eye,
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';
import { Textarea } from '../../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const AffiliateModal = ({ ctx }) => {
  const { showAffiliateModal, setShowAffiliateModal, affiliateForm, setAffiliateForm, handleCreateAffiliate } = ctx;
  return (
          <Dialog open={showAffiliateModal} onOpenChange={setShowAffiliateModal}>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle>Nieuwe Affiliate Aanmaken</DialogTitle>
                <DialogDescription>
                  Maak een kortingscode aan voor een influencer of partner.
                </DialogDescription>
              </DialogHeader>
              
              <div className="space-y-4 py-4">
                <div className="space-y-2">
                  <Label htmlFor="affiliate-name">Naam influencer *</Label>
                  <Input
                    id="affiliate-name"
                    data-testid="affiliate-name-input"
                    placeholder="bijv. MamaBlogger Anna"
                    value={affiliateForm.name}
                    onChange={e => setAffiliateForm(prev => ({ ...prev, name: e.target.value }))}
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="affiliate-code">Kortingscode *</Label>
                  <Input
                    id="affiliate-code"
                    data-testid="affiliate-code-input"
                    placeholder="bijv. ANNA20"
                    value={affiliateForm.code}
                    onChange={e => setAffiliateForm(prev => ({ ...prev, code: e.target.value.toUpperCase() }))}
                    className="font-mono uppercase"
                  />
                  <p className="text-xs text-muted-foreground">Dit is de code die klanten invullen voor korting</p>
                </div>

                <div className="space-y-2">
                  <Label htmlFor="affiliate-email">E-mail (optioneel)</Label>
                  <Input
                    id="affiliate-email"
                    data-testid="affiliate-email-input"
                    type="email"
                    placeholder="anna@email.com"
                    value={affiliateForm.email}
                    onChange={e => setAffiliateForm(prev => ({ ...prev, email: e.target.value }))}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label htmlFor="discount">Korting (%)</Label>
                    <Input
                      id="discount"
                      data-testid="affiliate-discount-input"
                      type="number"
                      min={0}
                      max={100}
                      value={affiliateForm.discount_percentage}
                      onChange={e => setAffiliateForm(prev => ({ ...prev, discount_percentage: parseInt(e.target.value) || 0 }))}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="commission">Commissie (%)</Label>
                    <Input
                      id="commission"
                      data-testid="affiliate-commission-input"
                      type="number"
                      min={0}
                      max={100}
                      value={affiliateForm.commission_percentage}
                      onChange={e => setAffiliateForm(prev => ({ ...prev, commission_percentage: parseInt(e.target.value) || 0 }))}
                    />
                  </div>
                </div>
              </div>

              <DialogFooter>
                <Button variant="outline" onClick={() => setShowAffiliateModal(false)}>
                  Annuleren
                </Button>
                <Button
                  data-testid="save-affiliate-btn"
                  onClick={handleCreateAffiliate}
                  className="bg-gold hover:bg-gold/90 text-night-blue"
                >
                  Aanmaken
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
  );
};
